export default __webpack_public_path__ + "static/media/Mattia_e_Viola_porte_cle.e8569ac1.png";